<template>
  <div class="Kanit" style="color: black">
    <div class="text-center Kanit" style="font-size: 25px; font-weight: 600">
      งานรอยืนยันบิล
    </div>
    <div class="pt-9">
      <v-card v-for="(job, k) in jobs" :key="k" outlined class="pa-2 pb-4">
        <div style="font-weight: 900; font-size: 11px; margin-bottom: 15px">
          JobID : #{{ job.orderid }} ลูกค้า {{ job.customer_name }}
        </div>
        <div class="px-3">
          <div style="display: flex; flex-direction: row">
            <div>
              <img
                style="height: 60px; width: 80px"
                :src="job.customer_profile_pic"
              />
            </div>
            <div style="align-self: center; margin-left: 20px; font-size: 10px">
              ผู้จ้าง: {{ job.customer_name }}
            </div>
          </div>
          <div style="font-size: 10px; font-weight: bold">
            <div style="font-size: 13px">รายละเอียดงาน</div>
            <div style="line-height: 15px">
              ประเภทงาน: {{ job.work_type }}<br />
              พื้นที่การทาสี: {{ job.work_area }} ตรม.<br />
              สถานที่ปฏิบัติงาน: {{ job.customer_address }}
            </div>
          </div>
        </div>

        <div class="px-4">
          <v-btn
            @click="goToUploadBill(job.orderid)"
            class="mt-3"
            small
            color="#14af43"
            outlined
            block
            rounded
            >ยืนยันบิล</v-btn
          >
        </div>
      </v-card>
    </div>
  </div>
</template>
<script>
import axios from "axios";
import moment from "moment";
export default {
  props: ["value"],
  data() {
    return {
      input: {
        remark: "",
      },
      saveloading: false,
      cancelModal: false,
      loading: "",
      currentCancel: "",
    };
  },
  computed: {
    jobs() {
      return this.value.orderlist.filter((el) => el.status == "รอยืนยันบิล");
    },
    query() {
      return this.$store.state.query;
    },
    profile() {
      return this.$store.state.profile;
    },
    moment() {
      return moment;
    },
  },
  methods: {
    goToUploadBill(id) {
      this.query.orderid = id;
      this.$store.state.redirect = "PainterProfile";
      this.query.view = "BillUpload";
    },
    // sendConfirmAgain(orderid) {
    //   var vm = this;
    //   this.$swal.fire({
    //     text: "ต้องการแจ้งเริ่มงานอีกครั้ง?",
    //     showCancelButton: true,
    //     confirmButtonText: "ยืนยัน",
    //     showLoaderOnConfirm: true,
    //     cancelButtonText: "ยกเลิก",
    //     preConfirm: () => {
    //       return new Promise((resolve, reject) => {
    //         vm.loading = orderid;
    //         var body = {
    //           userid: vm.profile.userId + "__" + vm.query.pageid,
    //           pageid: vm.query.pageid,
    //           orderid,
    //         };
    //         axios
    //           .post(
    //             "https://communitybotbyzwizai.herokuapp.com/toapainterreplyorderagain",
    //             body,
    //             {
    //               headers: {
    //                 AUTHORIZATION: "Bearer xxx xxx",
    //               },
    //             }
    //           )
    //           .then((response) => {
    //             if (response.data.responsecode == 200) {
    //               vm.$swal.fire({
    //                 icon: "success",
    //                 text: "สำเร็จ",
    //               });
    //             }
    //             vm.loading = "";
    //             resolve();
    //           });
    //       });
    //     },
    //   });
    // },
  },
};
</script>


